module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Example', {
    attrs: {
      "component": _vm.ExSimple,
      "code": _vm.ExSimpleCode,
      "vertical": ""
    }
  }), _vm._v(" "), _c('Example', {
    attrs: {
      "component": _vm.ExArray,
      "code": _vm.ExArrayCode,
      "title": "Grouped (Array)",
      "vertical": ""
    }
  }, [_c('p', [_vm._v("Just add the same "), _c('code', [_vm._v("v-model")]), _vm._v(" to multiple Checkboxes, and set a "), _c('code', [_vm._v("native-value")]), _vm._v(".")])]), _vm._v(" "), _c('Example', {
    attrs: {
      "component": _vm.ExSizes,
      "code": _vm.ExSizesCode,
      "title": "Sizes",
      "vertical": ""
    }
  }), _vm._v(" "), _c('Example', {
    attrs: {
      "component": _vm.ExTypes,
      "code": _vm.ExTypesCode,
      "title": "Types",
      "vertical": ""
    }
  }), _vm._v(" "), _c('Example', {
    attrs: {
      "component": _vm.ExCheckboxButton,
      "code": _vm.ExCheckboxButtonCode,
      "title": "Checkbox Button"
    }
  }, [_c('p', [_vm._v("You have to wrap them on a "), _c('router-link', {
    attrs: {
      "to": "/documentation/field"
    }
  }, [_vm._v("Field")]), _vm._v(".")], 1)]), _vm._v(" "), _c('ApiView', {
    attrs: {
      "data": _vm.api
    }
  }), _vm._v(" "), _c('VariablesView', {
    attrs: {
      "data": _vm.variables
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f09fc966"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./docs/pages/components/checkbox/Checkbox.vue
// module id = 1344
// module chunks = 20